/**
 * Created by mengxiaojiang on 2016/5/10.
 */

var InteractiveType = require('./InteractiveTypes.js');
var EnumData = InteractiveType.InteractiveTypes;
var findEnumValue = InteractiveType.getInteractiveParamValue;
var appTypes = require('../types/appTypes.js');
var RuntimeOptions = require('../views/RuntimeOption.js');
var dataHelper = require('../helper/dataHelper');
var _ = require('underscore');
var utils = require('../helper/util');

/**
 * 转换命令参数
 * @param paramName 要获取的信息数据名称
 * @param params 参数列表
 * @return 返回参数值，对于一些特定的属性，会进行转换处理，如x,y,w,h等会转换为数字
 * */
function getParamValue(paramName, params) {
  var value;
  if (params.hasOwnProperty(paramName)) {
    value = params[paramName];
  }
  switch (paramName) {
    // 纯数字类型数据
  case EnumData.CommandParams.PARAM_FROM_X:
  case EnumData.CommandParams.PARAM_FROM_Y:
  case EnumData.CommandParams.PARAM_TO_X:
  case EnumData.CommandParams.PARAM_TO_Y:
  case EnumData.CommandParams.PARAM_BY_X:
  case EnumData.CommandParams.PARAM_BY_Y:
  case EnumData.CommandParams.PARAM_FROM_SCALE_X:
  case EnumData.CommandParams.PARAM_FROM_SCALE_Y:
  case EnumData.CommandParams.PARAM_TO_SCALE_X:
  case EnumData.CommandParams.PARAM_TO_SCALE_Y:
  case EnumData.CommandParams.PARAM_FROM_WIDTH:
  case EnumData.CommandParams.PARAM_FROM_HEIGHT:
  case EnumData.CommandParams.PARAM_TO_WIDTH:
  case EnumData.CommandParams.PARAM_TO_HEIGHT:
  case EnumData.CommandParams.PARAM_FROM_ANGLE:
  case EnumData.CommandParams.PARAM_TO_ANGLE:
  case EnumData.CommandParams.PARAM_DELAY:
  case EnumData.CommandParams.PARAM_ANI_DURATION:
  case EnumData.CommandParams.PARAM_ROTATE_CENTER_X:
  case EnumData.CommandParams.PARAM_ROTATE_CENTER_Y:
  case EnumData.CommandParams.PARAM_SELECTED_INDEX: {
    return parseFloat(value);
  }
    //布尔类型数据
  case EnumData.CommandParams.PARAM_ANI_LOOP:
  case EnumData.CommandParams.PARAM_ANI_AUTO_REVERSE:
  case EnumData.CommandParams.PARAM_ANI_INTERPOLATION_TYPE_OUT:
  case EnumData.CommandParams.PARAM_TERMINATE_LOOP_BY_CLICK:
  case EnumData.CommandParams.PARAM_FORCE_FROM_INIT_VALUE:
  case EnumData.CommandParams.PARAM_VALUE_FROM_CURRENT: {
    return value === 'True' || value;
  }
    //移动命令的参数转换
  case EnumData.CommandParams.PARAM_MOVE_MODE: {
    return findEnumValue(EnumData.CommandMoveMode, value);
  }
  case EnumData.CommandParams.PARAM_MOVE_PLACE_HORI:
  case EnumData.CommandParams.PARAM_MOVE_PLACE_VERT: {
    return findEnumValue(EnumData.PosDirection, value);
  }

  case EnumData.CommandParams.PARAM_VALUE : {
    return value;
  }


  case EnumData.CommandParams.PARAM_VALUE_MODE: {
    return findEnumValue(EnumData.CommandValueMode, value);
  }


  case EnumData.CommandParams.PARAM_ANI_TYPE: {
    return value;
  }
  case EnumData.CommandParams.PARAM_ANI_INTERPOLATION: {
    return findEnumValue(EnumData.AniInterpolationType, value);
  }

  case EnumData.CommandParams.PARAM_SCALE_CENTER_MODE: {
    return findEnumValue(EnumData.CommandScaleDirection, value);
  }
  case EnumData.CommandParams.PARAM_RESIZE_TYPE: {
    return value;
  }
  case EnumData.CommandParams.PARAM_RESIZE_CENTER_MODE: {
    return findEnumValue(EnumData.CommandResizeDirection, value);
  }
  case EnumData.CommandParams.PARAM_ROTATE_DIRECTION: {
    return findEnumValue(EnumData.CommandRotateDirection, value);
  }
  case EnumData.CommandParams.PARAM_ROTATE_CENTER_MODE: {
    return findEnumValue(EnumData.RotateCenterPoint, value);
  }

  case EnumData.CommandParams.PARAM_SCROLL_TO: {
    return findEnumValue(EnumData.ScrollPosition, value);
  }
  default :
    return null;
  }
}

/**
 * 解析移动命令
 * @param command
 * @param cmdParams
 * @param targetComp
 * @param autoReverse
 */
function parseMoveCmd(command, cmdParams, targetComp, autoReverse) {
  var currentX;//当前视觉上的X坐标
  var currentY;//当前视觉上的Y坐标
  var toX; //视觉上的目标点X坐标
  var toY; //视觉上的目标点Y坐标
  var byX; //此次动画要偏移X距离
  var byY;// 此次动画要偏移的Y距离
  var moveMode;//移动的模式：移动|移动到|水平一个身位|垂直一个身位
  var moveDirection;// 移动的方向
  var currentW = parseInt(!_.isUndefined(targetComp.currentW) ? targetComp.currentW : targetComp.w, 10);// 组件当前的宽度
  var currentH = parseInt(!_.isUndefined(targetComp.currentH) ? targetComp.currentH : targetComp.h, 10);// 组件当前的高度

  toX = getParamValue(EnumData.CommandParams.PARAM_TO_X, cmdParams);
  toY = getParamValue(EnumData.CommandParams.PARAM_TO_Y, cmdParams);
  byX = getParamValue(EnumData.CommandParams.PARAM_BY_X, cmdParams);
  byY = getParamValue(EnumData.CommandParams.PARAM_BY_Y, cmdParams);

  moveMode = getParamValue(EnumData.CommandParams.PARAM_MOVE_MODE, cmdParams);

  moveDirection = null;

  currentX = parseInt(!_.isUndefined(targetComp.currentX) ? targetComp.currentX : targetComp.x, 10);
  currentY = parseInt(!_.isUndefined(targetComp.currentY) ? targetComp.currentY : targetComp.y, 10);
  //移动
  if (moveMode === EnumData.CommandMoveMode.MOVE_BY) {
    toX = currentX + byX;
    toY = currentY + byY;
  }
  //移动到
  else if (moveMode === EnumData.CommandMoveMode.MOVE_TO) {
    //这里因为已经获取到了终点的X,Y，不需要再时行其它的计算
  }
  //水平移动一个身位
  else if (moveMode === EnumData.CommandMoveMode.MOVE_PLACE_HORI) {
    moveDirection = getParamValue(EnumData.CommandParams.PARAM_MOVE_PLACE_HORI, cmdParams);
    //左移一个身位
    if (moveDirection === EnumData.PosDirection.LEFT) {
      toX = currentX - currentW;
    } else {
      //右移一个身位
      toX = currentX + currentW;
    }
    toY = currentY;
  }
  //垂直移动一个身位
  else {
    moveDirection = getParamValue(EnumData.CommandParams.PARAM_MOVE_PLACE_VERT, cmdParams);
    toX = currentX;
    //向下移动一个身位
    if (moveDirection === EnumData.PosDirection.DOWN) {
      toY = currentY + currentH;
    } else {
      //向上移动一个身位
      toY = currentY - currentH;
    }
  }

  command.params = {
    left: toX,
    top: toY
  };


  command.recovery = {
    left: currentX,
    top: currentY
  };

  if (!autoReverse) {
    targetComp.currentX = toX;
    targetComp.currentY = toY;
  }

}

/**
 * 解析旋转命令
 * @param targetComp
 * @param cmdParams
 * @param duration
 */
function parseRotateCmd(command, cmdParams, targetComp, autoReverse) {
  var direction = getParamValue(EnumData.CommandParams.PARAM_ROTATE_DIRECTION, cmdParams);
  var valueMode = getParamValue(EnumData.CommandParams.PARAM_VALUE_MODE, cmdParams);
  var centerMode = getParamValue(EnumData.CommandParams.PARAM_ROTATE_CENTER_MODE, cmdParams);
  var toAngle = getParamValue(EnumData.CommandParams.PARAM_TO_ANGLE, cmdParams);
  var fromOrigin = undefined;
  var currentAngle = !_.isUndefined(targetComp.currentAngle) ? targetComp.currentAngle : 0;


  var temp = 1;
  //反时针旋转
  if (direction === EnumData.CommandRotateDirection.COUNTER_CLOCKWISE) {
    temp = -1;
  }
  switch (valueMode) {
    //旋转到
  case EnumData.CommandValueMode.BY :
    toAngle = currentAngle + toAngle * temp;
    break;
  default :
    break;

  }
  switch (centerMode) {
  case EnumData.RotateCenterPoint.CENTER:
    fromOrigin = 'center center';
    break;
  case EnumData.RotateCenterPoint.TOP_LEFT:
    fromOrigin = 'left top';
    break;
  case EnumData.RotateCenterPoint.TOP:
    fromOrigin = 'center top';
    break;
  case EnumData.RotateCenterPoint.TOP_RIGHT:
    fromOrigin = 'right top';
    break;
  case EnumData.RotateCenterPoint.RIGHT:
    fromOrigin = 'right center';
    break;
  case EnumData.RotateCenterPoint.BOTTOM_RIGHT:
    fromOrigin = 'right bottom';
    break;
  case EnumData.RotateCenterPoint.BOTTOM:
    fromOrigin = 'center bottom';
    break;
  case EnumData.RotateCenterPoint.BOTTOM_LEFT:
    fromOrigin = 'left bottom';
    break;
  case EnumData.RotateCenterPoint.LEFT:
    fromOrigin = 'left center';
    break;
  }
  command.previourCSS = {
    transformOrigin: fromOrigin
  };

  command.params = {
    rotate: toAngle
  };
  command.recovery = {
    rotate: currentAngle
  };

  if (!autoReverse) {
    targetComp.currentAngle = toAngle;
  }
}

/**
 * 解析调整尺寸命令
 * @param command
 * @param cmdParams
 * @param targetComp
 * @param autoReverse
 */
function parseResizeCmd(command, cmdParams, targetComp, autoReverse) {
  var valueMode = getParamValue(EnumData.CommandParams.PARAM_VALUE_MODE, cmdParams);
  var currentX = parseInt(!_.isUndefined(targetComp.currentX) ? targetComp.currentX : targetComp.x, 10);
  var currentY = parseInt(!_.isUndefined(targetComp.currentY) ? targetComp.currentY : targetComp.y, 10);
  var currentW = parseInt(!_.isUndefined(targetComp.currentW) ? targetComp.currentW : targetComp.w, 10);
  var currentH = parseInt(!_.isUndefined(targetComp.currentH) ? targetComp.currentH : targetComp.h, 10);
  var toX;
  var toY;
  var toW;
  var toH;
  var centerMode;

  toW = getParamValue(EnumData.CommandParams.PARAM_TO_WIDTH, cmdParams);
  toH = getParamValue(EnumData.CommandParams.PARAM_TO_HEIGHT, cmdParams);
  //相对
  if (valueMode === EnumData.CommandValueMode.BY) {
    toW = currentW + toW;
    toH = currentH + toH;
  }
  centerMode = getParamValue(EnumData.CommandParams.PARAM_RESIZE_CENTER_MODE, cmdParams);

  //根据定位点计算X,Y坐标
  switch (centerMode) {
  case EnumData.CommandResizeDirection.LEFT: {
    toX = currentX;
    toY = currentY + (currentH - toH) / 2;
    break;
  }
  case EnumData.CommandResizeDirection.RIGHT: {
    toX = (currentX + currentW) - toW;
    toY = currentY + (currentH - toH) / 2;
    break;
  }
  case EnumData.CommandResizeDirection.TOP: {
    toX = currentX + (currentW - toW) / 2;
    toY = currentY;
    break;
  }
  case EnumData.CommandResizeDirection.BOTTOM: {
    toX = currentX + (currentW - toW) / 2;
    toY = (currentY + currentH) - toH;
    break;
  }
  case EnumData.CommandResizeDirection.TOP_LEFT: {
    toX = currentX;
    toY = currentY;
    break;
  }
  case EnumData.CommandResizeDirection.TOP_RIGHT: {
    toX = (currentX + currentW) - toW;
    toY = currentY;
    break;
  }
  case EnumData.CommandResizeDirection.BOTTOM_LEFT: {
    toX = currentX;
    toY = (currentY + currentH) - toH;
    break;
  }
  case EnumData.CommandResizeDirection.BOTTOM_RIGHT: {
    toX = (currentX + currentW) - toW;
    toY = (currentY + currentH) - toH;
    break;
  }
  case EnumData.CommandResizeDirection.CENTER: {
    toX = currentX + (currentW - toW) / 2;
    toY = currentY + (currentH - toH) / 2;
    break;
  }
  default : {
    toX = currentX;
    toY = currentY;
    break;
  }
  }


  command.params = {
    left: toX,
    top: toY,
    width: toW,
    height: toH,
    isResize: true
  };

  command.recovery = {
    left: currentX,
    top: currentY,
    width: currentW,
    height: currentH,
    isResize: true
  };

  if (!autoReverse) {
    targetComp.currentX = toX;
    targetComp.currentY = toY;
    targetComp.currentW = toW;
    targetComp.currentH = toH;
  }
}

/**
 * 解析缩放命令
 * @param command
 * @param cmdParams
 * @param targetComp
 * @param autoReverse
 */
function parseScaleCmd(command, cmdParams, targetComp, autoReverse) {
  var currentScaleX;
  var currentScaleY;
  var toScaleX;
  var toScaleY;
  var valueModel;
  var centerMode;
  var transformOrigin = undefined;

  valueModel = getParamValue(EnumData.CommandParams.PARAM_VALUE_MODE, cmdParams);
  centerMode = getParamValue(EnumData.CommandParams.PARAM_SCALE_CENTER_MODE, cmdParams);

  currentScaleX = 1;
  currentScaleY = 1;

  //这里必须要判断不为undefined，因为有可能该值为0；
  if (!_.isUndefined(targetComp.currentScaleX)) {
    currentScaleX = targetComp.currentScaleX;
  }
  if (!_.isUndefined(targetComp.currentScaleY)) {
    currentScaleY = targetComp.currentScaleY;
  }

  toScaleX = getParamValue(EnumData.CommandParams.PARAM_TO_SCALE_X, cmdParams);
  toScaleY = getParamValue(EnumData.CommandParams.PARAM_TO_SCALE_Y, cmdParams);

  //相对于当前比例进行缩放
  if (valueModel === EnumData.CommandValueMode.BY) {
    toScaleX = currentScaleX * toScaleX;
    toScaleY = currentScaleY * toScaleY;
  }
  // 这里默认定位到中心点时，坐标转换值不会变化，但视觉上的坐标全变化
  switch (centerMode) {
  case EnumData.CommandScaleDirection.LEFT :
    transformOrigin = 'left center';
    break;
  case EnumData.CommandScaleDirection.RIGHT :
    transformOrigin = 'right center';
    break;
  case EnumData.CommandScaleDirection.TOP :
    transformOrigin = 'center top';
    break;
  case EnumData.CommandScaleDirection.BOTTOM :
    transformOrigin = 'center bottom';
    break;
  case EnumData.CommandScaleDirection.TOP_LEFT :
    transformOrigin = 'left top';
    break;
  case EnumData.CommandScaleDirection.TOP_RIGHT :
    transformOrigin = 'right top';
    break;
  case EnumData.CommandScaleDirection.BOTTOM_LEFT :
    transformOrigin = 'left bottom';
    break;
  case EnumData.CommandScaleDirection.BOTTOM_RIGHT :
    transformOrigin = 'right bottom';
    break;
  case EnumData.CommandScaleDirection.CENTER :
    transformOrigin = 'center';
    break;
  default :
    transformOrigin = undefined;
    break;
  }
  command.previourCSS = {
    transformOrigin: transformOrigin
  };
  command.params = {
    scaleX: toScaleX,
    scaleY: toScaleY
  };

  command.recovery = {
    scaleX: currentScaleX,
    scaleY: currentScaleY
  };

  if (!autoReverse) {
    targetComp.currentScaleX = toScaleX;
    targetComp.currentScaleY = toScaleY;
  }
}

/**
 * 解析滚动命令
 * @param command
 * @param cmdParams
 * @param targetComp
 */
function parseScrollToCmd(command, cmdParams, targetComp) {
  var value = getParamValue(EnumData.CommandParams.PARAM_SCROLL_TO, cmdParams);
  var top;
  var portCom = targetComp.items[0];
  switch (value) {
  case EnumData.ScrollPosition.TOP:
    top = 0;
    break;
  case EnumData.ScrollPosition.CENTER:
    top = (targetComp.h - portCom.h) / 2;
    break;
  case EnumData.ScrollPosition.BOTTOM:
    top = targetComp.h - portCom.h;
    break;
  default:
    top = 0;
    break;
  }
  command.params = {
    top: top,
    useAnimate: false//暂不支持动画，如果以后有需要，可以扩展
  };
  command.isScrollFire = true;
}

/**
 * 解析内容面板切换命令
 * @param command
 * @param cmdParams
 * @param targetComp
 */
function parseStackCmd(command, cmdParams, targetComp) {
  var currentIndex = !_.isUndefined(targetComp.currentIndex) ? targetComp.currentIndex : parseInt(targetComp.selectedIndex, 10);
  var nextIndex = parseInt(cmdParams.SelecedIndex, 10);

  if (currentIndex >= targetComp.items.length) {
    currentIndex = 0;
  }
  //if (currentIndex === nextIndex) {
  //  return undefined;
  //}
  command.params = {
    nextIndex: nextIndex,
    currentIndex: currentIndex
  };
  command.isStackFire = true;
  targetComp.currentIndex = nextIndex;

}

/**
 * 解析可见性命令
 * @param command
 * @param cmdParams
 * @param targetComp
 * @param autoReverse
 */
function parseVisibleCmd(command, cmdParams, targetComp, autoReverse) {
  var value = findEnumValue(EnumData.CommandVisibility, cmdParams[EnumData.CommandParams.PARAM_VALUE]);
  var currentOpacity; // 组件的原始透明度
  var toOpacity; // 组件的目标透明度
  var toVisible;

  //当前是否可见
  var currentVisible = !_.isUndefined(targetComp.currentVisible) ? targetComp.currentVisible : targetComp.isShow;// 组件当前是否可见
  currentOpacity = parseFloat(targetComp.opacity);

  switch (value) {
  case EnumData.CommandVisibility.SHOW :
    toVisible = true;
    break;
  case EnumData.CommandVisibility.HIDE :
    toVisible = false;
    break;
  default:
    toVisible = !currentVisible;
    break;
  }
  toOpacity = toVisible ? currentOpacity : 0;

  command.params = {
    opacity: toOpacity,
    previourCSS: {
      visibility: toVisible ? 'visible' : 'hidden',
      display: toVisible ? 'block' : 'none',
      opacity: 0
    },
    afterCSS: {
      visibility: toVisible ? 'visible' : 'hidden',
      display: toVisible ? 'block' : 'none',

      //Allen:处理隐藏元素屏蔽下面元素的点击事件问题
      'pointer-events': toVisible ? 'auto' : 'none',
    }
  };
  //只有在即将显示的时候，才把目标预览作隐藏处理
  if (toVisible) {
    command.previourCSS = {
      visibility: toVisible ? 'visible' : 'hidden',
      display: toVisible ? 'block' : 'none',
      opacity: 0
    };
  }
  command.recovery = {
    opacity: toVisible ? 0 : currentOpacity
  };
  command.recoveryCSS = {
    visibility: currentVisible ? 'visible' : 'hidden',
    opacity: currentVisible ? currentOpacity : 0
  };

  if (!autoReverse) {
    targetComp.currentVisible = toVisible;
  }

  if (toVisible)
    doUpdateChildVisible(targetComp, toVisible);
}

function doUpdateChildVisible(groupCom, visible) {
  var item;
  var i = 0;
  if (groupCom.items) {
    for (i; i < groupCom.items.length; i++) {
      item = groupCom.items[i];
      item.isShow = visible;
      if (item.items) {
        doUpdateChildVisible(item, visible);
      }
    }
  }
}

/**
 * 解析弹出命令
 * @param page
 * @param command
 * @param cmdParams
 * @param targetComp
 * @param source
 */
//todo:mxj 这个命令之后不再解析弹出组件的弹出参数，仅处理是否弹出，源需要其延时多长时间启动，源组件ID，具体动画参数，由弹出管理类进行解析。这里只负责解析源组件命令中的参数
function parsePopupCmd(page, command, cmdParams, targetComp, source) {
  var currentPopupState = targetComp.popup || false;
  var contentComp = targetComp.items[1];
  var value = findEnumValue(EnumData.CommandPopupPanelState, cmdParams[EnumData.CommandParams.PARAM_VALUE]);
  var toPopupState;
  var isBackgroundFade = targetComp.isBackgroundFade;
  var isShowBackground = targetComp.isShowBackground;
  var duration = parseInt(targetComp.aniDuration, 10);
  var delay = parseInt(targetComp.delayBeforePopup, 10);
  var platform = page.state.page.platform;

  var contentW = parseInt(contentComp.w, 10);
  var contentH = parseInt(contentComp.h, 10);

  var positionPolicy = targetComp.positionPolicy;
  var positionMargin = parseInt(targetComp.posotionMargin, 10);
  var positionScreenMode = targetComp.positionScreenMode;
  var positionComMode = targetComp.positionComMode;
  var mobileEff = targetComp.aniType_Mobile;
  var aniEff = targetComp.aniType;
  var eff;
  var isSlidingDrawer = targetComp.controlTypeID === 'SlidingDrawer';

  //这三个数据，必须在命令解析前先好设置好
  //var pageHeight = parseInt(page.state.page.defaultH, 10);//parseInt(targetComp.pageSize.h, 10);
  //var pageWidth = parseInt(page.state.page.defaultW, 10);//parseInt(targetComp.pageSize.w, 10);

  var pageWidth = $('.stage-container')[0].clientWidth;
  var pageHeight = $('.stage-container')[0].clientHeight;


  //var screenOrientation = page.state.page.screenOrientation;

  //consele.log(page)
  var sourceComAbsoluteBounds;
  var option = {
    delay: delay,
    duration: duration,
    queue: false
  };

  //var temp;
  //if(screenOrientation === 'MoLandscape'){
  //  temp = pageWidth;
  //  pageWidth = pageHeight;
  //  pageHeight = temp;
  //}
  //var clipArea;

  targetComp.pageSize = {width: pageWidth, height: pageHeight};
  if (RuntimeOptions.eventTargetCom)
    targetComp.sourceBounds = page.getTargetEventComAbsoluteRect(RuntimeOptions.eventTargetCom);
  targetComp.platform = platform;


  switch (value) {
  case EnumData.CommandPopupPanelState.CLOSE:
    toPopupState = false;
    break;
  case EnumData.CommandPopupPanelState.POPUP:
    toPopupState = true;
    break;
  default:
    toPopupState = !currentPopupState;
    break;
  }
  targetComp.currentPopupState = toPopupState;
  delete targetComp.closeWithTrigger;
  if (toPopupState) {
    //doUpdateChildVisible(targetComp, true);
    //如果是抽屉
    if (isSlidingDrawer) {
      //contentComp.y = 0;
      contentComp.opacity = 1;
      if (targetComp.drawerSlideDirection === 'sdLeft') {
        //contentComp.x = -contentW;
        command.contentCommand = {
          params: {
            left: 0
          }
        };
        command.contentCommand.previourCSS = {
          left: -contentW
        };
      } else {
        //contentComp.x = pageWidth;
        command.contentCommand = {
          params: {
            left: pageWidth - contentW
          }
        };
        command.contentCommand.previourCSS = {
          left: pageWidth
        };
      }
    } else {
      //自由定位
      if (positionPolicy === appTypes.PositionPolicy.FREE) {
        //移动项目
        if (platform === appTypes.AppPlatformType.MOBILE || platform === appTypes.AppPlatformType.PAD) {
          eff = mobileEff;
          //clipArea = page.getClipAreaScrollView();
        } else if (platform !== appTypes.AppPlatformType.BLANK) {
          eff = aniEff;
        }
        if (!eff) {
          eff = appTypes.PopupPanelAniType.NONE;
        }
        if (contentComp.h + contentComp.y > pageHeight) {
          contentComp.y = Math.max(0, pageHeight - contentComp.h);
        }
        //TODO : mengxiaojiang 这里还缺少对拉长页面的处理
        switch (eff) {
        case appTypes.PopupPanelAniType_Mobile.NONE:
        case appTypes.PopupPanelAniType.NONE:
          //contentComp.opacity = 0;
          command.contentCommand = {
            params: {opacity: 1}
          };
          break;
        case appTypes.PopupPanelAniType_Mobile.FADE:
        case appTypes.PopupPanelAniType.FADE:
          contentComp.opacity = 0;
          command.contentCommand = {
            params: {opacity: 1}
          };
          break;
        case appTypes.PopupPanelAniType_Mobile.ZOOM_IN:
        case appTypes.PopupPanelAniType.ZOOM_IN:
          command.contentCommand = {
            params: {scale: 1}
          };
          break;
        case appTypes.PopupPanelAniType_Mobile.EXPAND_DOWN:
          contentComp.h = 0;
          command.contentCommand = {
            params: {
              height: contentH
            }
          };
          break;
        case appTypes.PopupPanelAniType_Mobile.EXPAND_RIGHT:
          contentComp.w = 0;
          command.contentCommand = {
            params: {
              width: contentW
            }
          };
          break;
        case appTypes.PopupPanelAniType_Mobile.MOVE_DOWN:
          contentComp.y = -contentH;
          command.contentCommand = {
            params: {
              top: 0
            }
          };
          break;
        case appTypes.PopupPanelAniType_Mobile.MOVE_UP:
          contentComp.y = pageHeight;
          contentComp.opacity = 1;
          command.contentCommand = {
            params: {
              top: pageHeight - contentH
            }
          };
          break;
        case appTypes.PopupPanelAniType_Mobile.MOVE_LEFT:
          contentComp.x = pageWidth;
          command.contentCommand = {
            params: {
              left: pageWidth - contentW
            }
          };
          break;
        case appTypes.PopupPanelAniType_Mobile.MOVE_RIGHT:
          contentComp.x = -contentW;
          command.contentCommand = {
            params: {
              left: 0
            }
          };
          break;
        }
      } else if (positionPolicy === appTypes.PositionPolicy.SCREEN) {
        //相对于屏幕定位
        if (platform !== appTypes.AppPlatformType.BLANK) {
          switch (positionScreenMode) {
          case appTypes.PositionScreenMode.TOP:
            contentComp.y = positionMargin;
            break;
          case appTypes.PositionScreenMode.CENTER:
            contentComp.y = (pageHeight - contentH) / 2;
            contentComp.x = (pageWidth - contentW) / 2;
            break;
          case appTypes.PositionScreenMode.BOTTOM:
            contentComp.y = pageHeight - contentH;
            break;
          }
          command.contentCommand = {};
        }
      } else {
        //相对于组件定位
        sourceComAbsoluteBounds = page.getTargetEventComAbsoluteRect(RuntimeOptions.eventTargetCom);
        switch (positionComMode) {
        case appTypes.PositionComMode.LEFT:
          contentComp.x = sourceComAbsoluteBounds.left - contentW;
          break;
        case appTypes.PositionComMode.RIGHT:
          contentComp.x = sourceComAbsoluteBounds.right;
          break;
        case appTypes.PositionComMode.TOP:
          contentComp.y = sourceComAbsoluteBounds.top - contentH;
          break;
        case appTypes.PositionComMode.BOTTOM:
          contentComp.y = sourceComAbsoluteBounds.bottom;
          break;
        }
        command.contentCommand = {};
      }
    }
    if (command.contentCommand) {
      command.contentCommand.option = option;
    }
    if (isShowBackground) {
      if (isBackgroundFade) {
        command.backgroundCommand = {
          params: {
            opacity: 1
          },
          option: option
        };
      } else {
        command.backgroundCSS = {
          opacity: 1
        }
      }
    }
    targetComp.currentX = 0;
    targetComp.currentY = 0;
    targetComp.currentW = pageWidth;
    targetComp.currentH = pageHeight;
    targetComp.measureWidth = pageWidth;
    targetComp.measureHeight = pageHeight;
    targetComp.popup = true;
  } else {
    targetComp.currentX = targetComp.x;
    targetComp.currentY = targetComp.y;
    targetComp.currentW = targetComp.w;
    targetComp.currentH = targetComp.h;
    targetComp.popup = false;
    targetComp.closeWithTrigger = true;
  }
  command.isPopupFire = true;
}


function parseColorCmd(command, cmdParams, targetComp, autoReverse) {
  var color = cmdParams[EnumData.CommandParams.PARAM_TO_VALUE];
  color = utils.Color.toHTMLColor(color);
  var currentColor = !_.isUndefined(targetComp.currentColor) ? targetComp.currentColor : targetComp.color;
  command.params = {
    color: color
  };
  command.recovery = {
    color: currentColor
  };
  //if (!autoReverse) {
  //  targetComp.currentColor = color;
  //}
  command.isPropsFire = true;
}


function parseTextCmd(command, cmdParams, targetComp, autoReverse) {
  var text = cmdParams[EnumData.CommandParams.PARAM_TO_VALUE];
  text = dataHelper.decodeURI(text);
  var currentText = !_.isUndefined(targetComp.currentText) ? targetComp.currentText : targetComp.text;
  command.params = {
    text: text
  };
  command.recovery = {
    text: currentText
  };
  //if (!autoReverse) {
  //  targetComp.currentText = text;
  //}

  //Allen:记录下设置文本交互发生的次数
  targetComp.setTextInteractiveNum = (targetComp.setTextInteractiveNum || 0)+1;

  command.isPropsFire = true;
}

function parsePropertyCmd(command,cmdType,cmdParams,targetComp,autoReverse){
  var propertyCmdList = EnumData.CommandType.CMD_PROPERTY;
  var propertyCmdItm;
  var k;
  var propertyName = undefined;
  var currentPropertyName;
  var oldValue;
  var fromValue;
  var toValue;
  for(k in propertyCmdList){
    propertyCmdItm = propertyCmdList[k];
    if(propertyCmdItm.cmd === cmdType){
      propertyName = propertyCmdItm.property;
      currentPropertyName = propertyCmdItm.current;
      break;
    }
  }

  if(!_.isUndefined(propertyName)){
    fromValue = oldValue = targetComp[currentPropertyName] || targetComp[propertyName];
    toValue = cmdParams[EnumData.CommandParams.PARAM_TO_VALUE];
    toValue = dataHelper.convertValue(propertyName,toValue);
    command.params = {};
    command.params[propertyName] = toValue;
    command.recovery = {};
    command.recovery[propertyName] = fromValue;
    command.isPropsFire = true;
  }
}
/**
 * 解析命令
 * @author mengxiaojiang
 * @date 2016-5-31
 * @param page 当前页面对象 React创建的页面对象，而不是一个JSON数据对象
 * @param command 解析后的命令对象，把解析后的结果存放到该对象顺，
 * @param commandData 原始的命令数据，读取该对象中的数据，并进行解析，不可修改该对象中的数据
 * @param targetComp 目标数据对象
 * @param source 事件源数据对象
 */
function parseCmd(page, command, commandData, targetComp, source) {
  var _params = {};
  var cmdParams = commandData.param;
  var cmdType = commandData.name;
  var option;
  var autoReverse;
  var i;
  var interpolation;
  var duration;
  var easing = 'swing';
  for (i = 0; i < cmdParams.length; i++) {
    _params[cmdParams[i].name] = cmdParams[i].value;
  }
  interpolation = getParamValue(EnumData.CommandParams.PARAM_ANI_INTERPOLATION, _params);
  duration = getParamValue(EnumData.CommandParams.PARAM_ANI_DURATION, _params);
  //*同名动画，使用jquery中的easeIn...  mxj 2.16-9-28
  switch (interpolation) {
    //加速
  case EnumData.AniInterpolationType.ACCELERATIVE:
    easing = 'easeInCubic';
    break;
    //回退
  case EnumData.AniInterpolationType.BACK:
    easing = 'easeInBack';
    break;
    //弹跳
  case EnumData.AniInterpolationType.BOUNCE:
    easing = 'easeInBounce';
    break;
    //伸缩
  case EnumData.AniInterpolationType.ELASTIC:
    easing = 'easeInElastic';
    break;
    //线性
  case EnumData.AniInterpolationType.LINEAR:
    easing = 'linear';
    break;
  case EnumData.AniInterpolationType.NONE:
    duration = 0;
    break;

  }

  autoReverse = getParamValue(EnumData.CommandParams.PARAM_ANI_AUTO_REVERSE, _params);
  option = {
    duration: duration,
    delay: getParamValue(EnumData.CommandParams.PARAM_DELAY, _params),
    autoReverse: autoReverse,
    easing: easing,
    aniInterpolation: getParamValue(EnumData.CommandParams.PARAM_ANI_INTERPOLATION, _params)//考虑下载JQUERY的动画类型库来实现丰富的动画类型
  };

  if (!command) {
    command = {};
  }

  command.option = option;

  switch (cmdType) {
  case EnumData.CommandType.CMD_MOVE:
    parseMoveCmd(command, _params, targetComp, autoReverse);
    break;
  case EnumData.CommandType.CMD_POPUP_STATE :
    parsePopupCmd(page, command, _params, targetComp, source);
    break;
  case EnumData.CommandType.CMD_VISIBILITY :
    parseVisibleCmd(command, _params, targetComp, autoReverse);
    break;
  case EnumData.CommandType.CMD_ROTATE :
    parseRotateCmd(command, _params, targetComp, autoReverse);
    break;
  case EnumData.CommandType.CMD_RESIZE :
    parseResizeCmd(command, _params, targetComp, autoReverse);
    break;
  case EnumData.CommandType.CMD_SCALE :
    parseScaleCmd(command, _params, targetComp, autoReverse);
    break;
  case EnumData.CommandType.CMD_SCROLL :
    parseScrollToCmd(command, _params, targetComp);
    break;
  case EnumData.CommandType.CMD_STACKPANEL_SWTICH :
    parseStackCmd(command, _params, targetComp);
    break;
  case EnumData.CommandType.CMD_COLOR:
    parseColorCmd(command, _params, targetComp, autoReverse);
    break;
  case EnumData.CommandType.CMD_TEXT:
    parseTextCmd(command, _params, targetComp, autoReverse);
    break;
  default:
    parsePropertyCmd(command,cmdType,_params,targetComp,autoReverse);
    break;
  }
}


exports.parser = parseCmd;


// WEBPACK FOOTER //
// ./src/interactive/InteractiveParse.js